/* eslint-disable */ 
import Vue from 'vue';
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import router from './router';
import Breadcrumbs from './components/bread_crumbs';
import store  from './store';
import firebase from 'firebase/app';
import Vue2Filters from 'vue2-filters';
import VueSweetalert2 from 'vue-sweetalert2';
import VueFormWizard from 'vue-form-wizard';
import VueTour from 'vue-tour';
import Notifications from 'vue-notification';
import { Vue2Dragula } from 'vue2-dragula';
import Toasted from 'vue-toasted';
import SmartTable from 'vuejs-smart-table';
import * as VueGoogleMaps from 'vue2-google-maps';
import { VueMasonryPlugin } from 'vue-masonry';
import VueFeather from 'vue-feather';
import VueApexCharts from 'vue-apexcharts';
import FunctionalCalendar from 'vue-functional-calendar';
import vueKanban from 'vue-kanban';
import axios from 'axios';
import vSelect from 'vue-select';
import OtpInput from "@bachdgvn/vue-otp-input";
import Vuelidate from 'vuelidate'
import VueCryptojs from 'vue-cryptojs'
import DisableAutocomplete from 'vue-disable-autocomplete';
import { preventReadonly } from './mixins/readonly';
import VueClipboard from 'vue-clipboard2'
import VCalendar from 'v-calendar';
import { detectBrowser } from './_services/broswerType'
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});
VueClipboard.config.autoSetContainer = true 
Vue.mixin(preventReadonly);
Vue.use(VueClipboard)
Vue.use(DisableAutocomplete);
Vue.use(VueCryptojs)
Vue.use(Vuelidate)

import IdleVue from "idle-vue";
const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 300000, // 3 minutes
  startAtIdle: false
});
import 'animate.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/src/jquery.js'
import 'bootstrap/dist/js/bootstrap.min.js'
Vue.component('v-select', vSelect)
Vue.component("v-otp-input", OtpInput);
const type = detectBrowser()
// authentication baseURL
axios.defaults.baseURL = 'https://digitaltest.tajbank.com/Authentication-Api-Middleware-Sec/api/v1/';

// Retail instance URL
const retailApiInstance = axios.create({
  baseURL: 'https://digitaltest.tajbank.com/Retail-Api-Middleware-Sec/api/v1'
});

Vue.prototype.$http = retailApiInstance


import PxCard  from './components/Pxcard.vue';
Vue.component(PxCard.name, PxCard);

import { Icon } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;

// Multi Language Add
import en from './locales/en.json';
import es from './locales/es.json';
import { defaultLocale, localeOptions } from './constants/config';
import VueI18n from 'vue-i18n';

// Import Theme scss
import './assets/scss/app.scss';
import 'vue-select/src/scss/vue-select.scss';
// import "vue-select/dist/vue-select.css";

// import 'vue-search-select/dist/VueSearchSelect.css'

// config for firebase
import config from './config.json';


Icon.Default.mergeOptions({
  iconRetinaUrl: require('./assets/images/vue2leaflet/marker-icon.png'),
  iconUrl: require('./assets/images/vue2leaflet/marker-icon.png')
});

Vue.use(VueFeather);

Vue.use(Toasted,{
  iconPack: 'fontawesome'
});
Vue.use(Vue2Dragula);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBM9fI-LWrZFd8b0Pi3Th6xFAr31-0PU_E',
    libraries: 'places',
  },
});

Vue.use(Notifications);
Vue.use(Vue2Filters);
Vue.use(VueSweetalert2);
Vue.use(VueFormWizard);
Vue.use(VueTour);
Vue.use(BootstrapVue);
Vue.use(SmartTable);
Vue.use(require('vue-chartist'));
Vue.use(require('vue-moment'));
Vue.component('Breadcrumbs', Breadcrumbs);
Vue.use(VueMasonryPlugin);
Vue.component('apexchart', VueApexCharts);
Vue.use(FunctionalCalendar, {
  dayNames: ['M', 'T', 'W', 'T', 'F', 'S', 'S']
});
Vue.use(vueKanban);
Vue.use(VueI18n);


const messages = { en: en, es: es };
const locale = (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale;
const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true
});

Vue.config.productionTip = false;
firebase.initializeApp(config.firebase);
// guard routes if user is not logged in
// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (!store.getters.isLoggedIn) {
//       next({
//         path: '/auth/login',
//         query: { redirect: to.fullPath }
//       });
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });
// get pin code from local storage
// const pinRequired = localStorage.getItem('pinRequired');
// const securityRequired = localStorage.getItem('isSecurityQuestion');
// // if pin required is true route to pin page else route to dashboard
// router.beforeEach((to, from, next) => {
//   if (pinRequired === 'true') {
//     next({
//       path: '/settings/create-pin'
//     });
//   } else if (securityRequired === 'true') {
//     next({
//       path: '/settings/reset-security-question'
//     });
//   } else {
//     next();
//   }
// });
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    } else {
      next({
        path: '/auth/login',
        query: { redirect: to.fullPath }
      });
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    if (!store.getters.isLoggedIn) {
      next();
      return;
    } else {
      next({
        path: '/dashboard/default',
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  }
});

// export const db = firebase.firestore();

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');